// @ts-nocheck
import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common/typings';
import b from 'b_';
import cx from 'classnames';
import isEqual from 'lodash/isEqual';
import {
    getExperimentTestId,
    H1,
    H2,
    showIntlMessageNotification as showIntlMessageNotificationAction,
    Spin,
    Text,
    withHookProps,
} from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import { Redirect, Route, Switch } from 'platform-components/src/components/router/router';
import { getMe } from 'platform-components/src/components/user/selectors';
import {
    withRouterPath,
    InjectedProps as WithRouterPathProps,
} from 'platform-components/src/utils/hocs/with-router-path/with-router-path';
import { getExactPathMatch } from 'platform-components/utils';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React, { ComponentType } from 'react';
import { connect } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { useMedia } from 'react-use';

import ClosingLessonModal from 'common.components/closing-lesson-modal/closing-lesson-modal';
import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import CopyLessonModal from 'common.components/copy-lesson-modal/copy-lesson-modal';
import { CustomLessonInfoModal } from 'common.components/custom-lesson-info-modal/custom-lesson-info-modal';
import { actions as lessonActions } from 'common.components/lesson';
import { SubscriptionModal } from 'common.components/lesson-view.subscription-modal/subscription-modal';
import * as lessonSelectors from 'common.components/lesson/selectors/common';
import PageContentTitle from 'common.components/page-content-title/page-content-title';
import SubjectsNavList from 'common.components/subjects-nav/__list/subjects-nav__list';
import { getIsTeamBuilderActive } from 'common.components/team-builder/selectors';
import { getClasses, getCurrentClass } from 'common.components/user/selectors';
import { CourseSubjectEx } from 'store/courses/typings';
import { getInitialSubject, getSubjectLibraryConfig, getSubjectLibraryTabs } from 'store/subject-config/selectors';
import { getIsTeacherFromMes } from 'utils/external-lms/external-lms';
import type { PropsWithClassId, PropsWithGrade } from 'utils/selectors/selectors';
import { YM_LOCATION } from 'utils/ym-constants';

import { BetaBanner } from 'common.components/beta-banner/beta-banner';
import { GradeSelect } from 'common.components/grade-select/grade-select';
import { useCalendarPlanThemes, CalendarPlanQuery } from 'store/calendar-plan/withCalendarPlanQuery';
import { CalendarPlanSkeleton } from '../../library.calendar-plan.new/_skeleton-view/calendar-plan_skeleton-view';
import Content from '../__content/library__content';
import LibraryTabs from '../__tabs/library__tabs';
import type { ReduxTeacherStore, RootAction } from '../../../typings';
import EmptyState, { EMPTY_STATE_ACTION } from '../../empty-state/empty-state';
import { CourseContainerPreviewList } from '../../library.course-container-list/course-container-preview-list';
import { LibraryCourseContainer as CourseContainer } from '../../library.course-container/course-container';
import { LibraryPromoSSRContainer } from '../../library.promo/promo.ssr.container';
import { LibrarySearch } from '../../library.search/search';
import {
    getCurrentShowcaseSlug,
    getCurrentSubjectPageSlug,
    getIsSubjectListLoading,
    getPreviewSubjectLists,
    getSearchConfig,
    getShouldShowLibrarySearch,
    getSubjectLists,
} from '../../library.store/selectors';
import { SCREEN_QUERY } from '../../library.sidebar/constants';

import { Library__informatics } from '../__informatics/library__informatics';
import { withSubjectGrades, SubjectGradesProps } from '../withSubjectGrades';
import { actions as lessonWidgetActions } from './../../lesson-editor-widget/actions';

const COURSE_NAV_METRIKA_PARAMS = { location: 'library' };

import './library__subject-manager.scss';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface OwnProps extends WithRouterPathProps {
    isPreview?: boolean;
    isMobile?: boolean;
}

interface Props extends OwnProps, StoreProps, DispatchProps, SubjectGradesProps {
    calendarPlanWithThemes?: ReturnType<typeof useCalendarPlanThemes>;
}

function stringifySubjectWithGrade({ subject, grade }: CourseSubjectEx) {
    return `${subject}/${grade}`;
}

interface SubjectAndGrade {
    subject: string;
    grade: number;
}

function parseSubjectWithGrade(value: string): SubjectAndGrade {
    const i = value.lastIndexOf('/');
    const subject = value.slice(0, i);
    const grade = +value.slice(i + 1);

    return { subject, grade };
}

const LibrarySubjectManagerWithMedia = (props: Props) => {
    const isMobile = useMedia(SCREEN_QUERY.SMALL);

    return <LibrarySubjectManager {...props} isMobile={isMobile} />;
};

export class LibrarySubjectManager extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    componentDidMount(): void {
        // обнуляем скролл, т.к. возможны переходы с других проскролленых страниц
        document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        this.redirectToLibrary();
    }

    componentDidUpdate(prevProps: Props): void {
        /* eslint complexity: [2, 11] */

        const {
            match: {
                params: { subject: prevSubject },
            },
            tabs: prevTabs,
            teamId: prevTeamId,
        } = prevProps;
        const {
            location: { pathname },
            match: {
                params: { subject },
            },
            tabs,
            teamId,
            isPreview,
            calendarPlanWithThemes,
        } = this.props;
        const { staticUrls } = this.context;

        const isSubjectChanged = prevSubject !== subject;
        const isTeamChanged = prevTeamId && teamId && prevTeamId !== teamId;
        const areTabsChanged = !isEqual(tabs, prevTabs);

        if (isTeamChanged) {
            this.resetLesson();
        }

        if (isSubjectChanged) {
            this.redirectToLibraryTab();

            this.resetLesson();
        }

        if (areTabsChanged) {
            this.redirectToLibrary();
        }

        const isLibrarySubjectPath = matchPath(pathname, {
            exact: true,
            path: [staticUrls.labLibrarySubject, staticUrls.deepLabLibrary],
        });
        // если по выбранным грейду и предмету есть календарный план
        if (isLibrarySubjectPath && !calendarPlanWithThemes.isLoading && calendarPlanWithThemes?.data) {
            this.redirectToSpecificTab(SUBJECT_LIBRARY_TAB_SLUG.calendarPlan);
        }

        if (isPreview) {
            // Возможно, subjects загрузились
            // Вызов не навредит: он только заполняет пропущенные параметры
            this.redirectInPreview();
        }
    }

    componentWillUnmount() {
        const { clearEditor, hasActiveDraft, toggleLessonWidget } = this.props;

        if (hasActiveDraft) {
            // @see https://st.yandex-team.ru/EDUCATION-22730
            setTimeout(() => this.showDraftSavedToast(), 0);
        }

        clearEditor();
        toggleLessonWidget(false);
    }

    redirectToSpecificTab = (tabSlug: string): void => {
        const {
            getRouterPath,
            history,
            location: { search },
            teamId,
        } = this.props;
        const { staticUrls } = this.context;
        const path = teamId ? staticUrls.labClassLibrarySubjectTab : staticUrls.labLibrarySubjectTab;

        history.replace(`${getRouterPath(path, { tabSlug })}${search}`);
    };

    // eslint-disable-next-line complexity
    redirectInPreview = (): void => {
        const {
            getRouterPath,
            history,
            location: { search },
            match: {
                params: {
                    classId: matchClassIdStr,
                    subject: matchSubject,
                    grade: matchGradeStr,
                    containerSlug: matchContainerSlug,
                },
            },
            subjects,
            teams,
        } = this.props;
        const { staticUrls } = this.context;

        if (!subjects?.length) {
            return;
        }

        const matchClassId = matchClassIdStr === undefined ? undefined : Number(matchClassIdStr),
            matchGrade = Number(matchGradeStr); // NaN is fine

        let classId: number | undefined = matchClassId,
            containerSlug: string | undefined = matchContainerSlug,
            grade: number | undefined = matchGrade,
            subject = matchSubject;

        const container = containerSlug && subjects.find((s) => s.slugs?.includes(containerSlug!));

        if (container) {
            ({ subject, grade } = container);
        } else {
            containerSlug = undefined;

            if (!subject || !subjects.some((s) => s.subject === subject)) {
                subject = subjects[0].subject;
            }

            if (!grade || !subjects.some((s) => s.subject === subject && s.grade === grade)) {
                grade = subjects.find((s) => s.subject === subject)!.grade;
            }
        }

        if (teams.length) {
            if (!classId || !teams.some((t) => t.id !== classId)) {
                classId = (teams.find((t) => t.level === grade) || teams[0]).id;
            }
        } else {
            classId = undefined;
        }

        if (
            grade &&
            (classId !== matchClassId ||
                subject !== matchSubject ||
                grade !== matchGrade ||
                containerSlug !== matchContainerSlug)
        ) {
            const path = classId // eslint-disable-line no-nested-ternary
                ? containerSlug
                    ? staticUrls.labClassCoursesPreviewCourse
                    : staticUrls.labClassCoursesPreviewSubjectGrade
                : containerSlug
                ? staticUrls.labPreviewCourse
                : staticUrls.labPreviewSubjectGrade;

            history.replace(
                `${getRouterPath(path, {
                    classId,
                    subject,
                    grade: grade || undefined,
                    containerSlug,
                })}${search}`
            );
        }
    };

    redirectToLibrary = (): void => {
        const {
            location: { pathname },
            isPreview,
        } = this.props;
        const { staticUrls } = this.context;

        if (isPreview) {
            this.redirectInPreview();
            return;
        }

        const isLibrarySubjectTabsPath = [staticUrls.labLibrarySubjectTab, staticUrls.labClassLibrarySubjectTab].some(
            (path) => matchPath(pathname, { path, exact: true })
        );

        if (!isLibrarySubjectTabsPath) {
            this.redirectToLibraryTab();
        }
    };

    redirectToLibraryTab = (): void => {
        const {
            location: { pathname },
            calendarPlanWithThemes,
        } = this.props;
        const { staticUrls } = this.context;

        const isLibrarySubjectPath = [staticUrls.labLibrarySubject, staticUrls.deepLabLibrary].some((path) =>
            matchPath(pathname, { path, exact: true })
        );

        if (isLibrarySubjectPath && !calendarPlanWithThemes?.isLoading && calendarPlanWithThemes?.data) {
            this.redirectToSpecificTab(SUBJECT_LIBRARY_TAB_SLUG.calendarPlan);
        }
    };

    resetLesson = () => {
        const { clearEditor, lessonId, toggleLessonWidget } = this.props;

        if (lessonId) {
            // @see https://st.yandex-team.ru/EDUCATION-22730
            setTimeout(() => this.showDraftSavedToast(), 0);
        }

        clearEditor();
        toggleLessonWidget(false);
    };

    showDraftSavedToast = () => {
        const { showIntlMessageNotification } = this.props;

        showIntlMessageNotification({
            closeDelay: COMMON_NOTIFICATION_DELAY,
            gravity: GRAVITIES.BOTTOM,
            messageId: 'lesson.clessonDraftIsSavedToast',
            theme: NOTIFICATION_THEMES.TOAST,
        });
    };

    handleSelectCourse = (subject: string, parsed: string | SubjectAndGrade): void => {
        const {
            getRouterPath,
            history,
            teamId,
            location: { search },
            match: {
                params: { classId },
            },
            isPreview,
            subjectGradesInfo,
        } = this.props;
        const { staticUrls } = this.context;

        const queryParams = qs.parse(search);
        const gradeFromQuery = queryParams.grade;

        // определяем соответствует ли грейд из query грейдам предмета
        // если нет, выбираем первый из списка
        const subjectGrades = (subjectGradesInfo.subjectGrades?.[subject] ?? []).map((gradeObj) => gradeObj.grade);
        const currentGrade = subjectGrades.includes(Number(gradeFromQuery)) ? gradeFromQuery : subjectGrades[0];

        const params = qs.stringify({ ...queryParams, grade: currentGrade });

        if (isPreview) {
            history.push(
                `${getRouterPath(
                    classId ? staticUrls.labClassCoursesPreviewSubjectGrade : staticUrls.labPreviewSubjectGrade,
                    parsed as SubjectAndGrade
                )}?${params}`
            );
        } else {
            history.push(
                `${getRouterPath(teamId ? staticUrls.labLibrarySubject : staticUrls.deepLabLibrary, {
                    subject,
                })}?${params}`
            );
        }
    };

    getPageTitle = () => {
        const {
            match: {
                params: { subject },
            },
            subjects,
        } = this.props;

        const currentSubject = subjects.find((courseSubject) => courseSubject.subject === subject)?.name;

        if (currentSubject) {
            return <H2>{currentSubject}</H2>;
        }

        return <H2 id="library.header" />;
    };

    renderPreviewListTitleBlock = () => {
        return (
            <PageContentTitle
                mix="library-subject-manager__preview-page-title"
                subTitle={<Text id="libraryPage.previewList.description" />}
                title={<H1 id="libraryPage.previewList.title" />}
            />
        );
    };

    // eslint-disable-next-line complexity
    renderLibrarySubjectNav = (): React.ReactNode => {
        const {
            match: {
                params,
                params: { subject },
            },
            teamId,
            testId,
            currentShowcaseSlug,
            currentSubjectPageSlug,
            subjects,
            me,
            grade,
            isPreview,
            isMobile,
            subjectGradesInfo,
            currentTeam,
        } = this.props;

        if (!subjectGradesInfo?.isSuccess || !subjectGradesInfo.subjectGrades) {
            return null;
        }

        // грейды текущего предмета из параметров урла
        const grades = (subjectGradesInfo.subjectGrades[subject] ?? []).map((gradeObj) => gradeObj.grade);

        // для публичной витрины - все предметы
        // для не публичной - только выданные в класс
        const currentSubjects = currentTeam ? subjects : subjectGradesInfo.orderedSubjects;

        const metrikaParams = {
            ...COURSE_NAV_METRIKA_PARAMS,
            test_id: testId,
            general_showcase_slug: currentShowcaseSlug,
            subject_page_showcase_slug: currentSubjectPageSlug,
        };

        const isInformatics = subject === 'informatics';

        if (currentSubjects.length) {
            let shouldShowGradeSelect = false;

            if (!isPreview) {
                if (!teamId) {
                    shouldShowGradeSelect = true;
                } else {
                    shouldShowGradeSelect = isInformatics;
                }
            }

            return (
                <div
                    className={cx(
                        'library__subject-tabs',
                        isPreview && 'library-subject-manager__preview-page-subjects'
                    )}
                >
                    <SubjectsNavList
                        currentSubject={isPreview ? stringifySubjectWithGrade(params as any) : subject}
                        me={me}
                        metrikaParams={metrikaParams}
                        onSelect={this.handleSelectCourse}
                        parse={isPreview ? parseSubjectWithGrade : undefined}
                        stringify={isPreview ? stringifySubjectWithGrade : undefined}
                        subjects={currentSubjects}
                        teamLevel={grade}
                    />
                    {shouldShowGradeSelect && (
                        <GradeSelect
                            grades={grades}
                            mix="library__grade-select"
                            showEgeTab={isInformatics}
                            type={isMobile ? 'select' : 'tabs'}
                        />
                    )}
                </div>
            );
        }

        return <PageContentTitle title={this.getPageTitle()} />;
    };

    // eslint-disable-next-line complexity
    renderLibraryWrapper = (child?: React.ReactNode, renderTitleBlock?: () => JSX.Element): React.ReactNode => {
        const {
            searchConfig,
            subjectLibraryConfig,
            isPreview,
            isTeacherFromMes,
            match: {
                params: { subject },
            },
            location: { pathname },
            calendarPlanWithThemes,
        } = this.props;

        const { staticUrls } = this.context;

        let shouldShowTabs = subjectLibraryConfig?.show_tabs;
        if (typeof shouldShowTabs === 'undefined') {
            shouldShowTabs = true;
        }

        if (subject === 'informatics') {
            shouldShowTabs = false;
        }

        const searchParams = searchConfig?.query ? qs.parse(searchConfig.query) : {};

        const filters = isTeacherFromMes ? { subjects: [subject as string] } : undefined;

        const showCalendarPlanSkeleton =
            calendarPlanWithThemes?.isLoading &&
            !!matchPath(pathname, {
                path: [
                    staticUrls.labLibrarySubject,
                    staticUrls.labClassLibrarySubjectCalendarPlanTheme,
                    staticUrls.labLibrarySubjectCalendarPlan,
                ],
                exact: true,
            });

        return (
            <div className={b('library', { empty: !child })}>
                {subject === 'informatics' && <BetaBanner className="library__beta-banner" section="materials" />}
                {isPreview ||
                    (searchConfig && (
                        <LibrarySearch
                            filters={filters}
                            namespaceIds={searchConfig.namespace_ids}
                            params={searchParams}
                        />
                    ))}
                {renderTitleBlock?.()}
                {this.renderLibrarySubjectNav()}
                {isPreview || (!isTeacherFromMes && shouldShowTabs && <LibraryTabs />)}
                {showCalendarPlanSkeleton ? <CalendarPlanSkeleton /> : child}
                {isPreview || (
                    <>
                        <CustomLessonInfoModal />
                        <ClosingLessonModal />
                        <CopyLessonModal />
                        <SubscriptionModal />
                    </>
                )}
            </div>
        );
    };

    renderCourseContainer = () => {
        const {
            match: {
                params: { subject },
            },
        } = this.props;

        if (subject === 'informatics') {
            return this.renderLibraryWrapper(<Library__informatics />);
        }

        return this.renderLibraryWrapper(<CourseContainer className="library__course-container" />);
    };

    renderPreviewCourseContainer = () => {
        return this.renderLibraryWrapper(<CourseContainer className="library__course-container" isPreview={true} />);
    };

    renderPreviewCourseContainerList = () => {
        return this.renderLibraryWrapper(<CourseContainerPreviewList />, this.renderPreviewListTitleBlock);
    };

    renderLibrary = () => {
        const showBackToCalendarPlan =
            !this.props.calendarPlanWithThemes?.isLoading && !!this.props.calendarPlanWithThemes?.data;
        return this.renderLibraryWrapper(<Content showBackToCalendarPlan={showBackToCalendarPlan} />);
    };

    renderPromo = () => {
        return this.renderLibraryWrapper(<LibraryPromoSSRContainer />);
    };

    // eslint-disable-next-line complexity
    renderContent = () => {
        const {
            match: {
                params: { subject },
            },
            subjects,
            location: { pathname, search },
            getRouterPath,
            initialSubject,
            teamId,
            isTeamBuilderActive,
            isPreview,
            currentTeam,
            classId,
        } = this.props;
        const { staticUrls } = this.context;

        // оставляем логику проверки наличия предмета в курсах, только для учителя с классом
        if (currentTeam || classId) {
            if (!subjects.length) {
                if (isPreview) {
                    return <Spin center />;
                }

                // не редиректим, пока team-builder добавляет класс и обновляет getCourses
                if (subject && teamId && !isTeamBuilderActive) {
                    return <Redirect to={getRouterPath(staticUrls.labClassLibrary, { classId: teamId })} />;
                }

                return (
                    <div className="library">
                        <EmptyState
                            action={EMPTY_STATE_ACTION.ADD_SUBJECT}
                            locationForMetrika={YM_LOCATION.LIBRARY}
                            textId="library.emptyState.noSubject"
                        />
                    </div>
                );
            }

            if (!isPreview && !subjects.some((item) => item.subject === subject)) {
                const correctSubject = subjects.map((s) => s.subject).includes(initialSubject)
                    ? initialSubject
                    : subjects[0].subject;
                let { path = null, params } = getExactPathMatch(staticUrls, pathname) || {};

                if (path === staticUrls.labLibrarySubjectCollection) {
                    path = staticUrls.labLibrarySubject;
                }

                if (!params?.subject) {
                    path = teamId ? staticUrls.labLibrarySubject : staticUrls.deepLabLibrary;
                }

                if (path) {
                    const newPath = getRouterPath(path, { subject: correctSubject });
                    return <Redirect to={`${newPath}${search}`} />;
                }

                return null;
            }
        }

        return (
            <Switch>
                <Route exact path={staticUrls.labCoursesPreview} render={this.renderWaiting} />
                <Route exact path={staticUrls.labPreviewSubject} render={this.renderWaiting} />
                <Route exact path={staticUrls.labPreviewSubjectGrade} render={this.renderPreviewCourseContainerList} />
                <Route exact path={staticUrls.labPreviewCourse} render={this.renderPreviewCourseContainer} />
                <Route exact path={staticUrls.labClassCoursesPreview} render={this.renderWaiting} />
                <Route exact path={staticUrls.labClassCoursesPreviewSubject} render={this.renderWaiting} />
                <Route
                    exact
                    path={staticUrls.labClassCoursesPreviewSubjectGrade}
                    render={this.renderPreviewCourseContainerList}
                />
                <Route
                    exact
                    path={staticUrls.labClassCoursesPreviewCourse}
                    render={this.renderPreviewCourseContainer}
                />
                <Route exact path={staticUrls.labLibrarySubjectCollection} render={this.renderCourseContainer} />
                <Route
                    exact
                    path={staticUrls.labLibrarySubjectCommonCourseContainer}
                    render={this.renderCourseContainer}
                />
                <Route exact path={staticUrls.deepLabPromoTabSection} render={this.renderPromo} />
                <Route exact path={staticUrls.labLibrarySubjectPromo} render={this.renderPromo} />
                <Route render={this.renderLibrary} />
            </Switch>
        );
    };

    /**
     * Нет смысла рендерить что-то осмысленное, если мы делаем редирект
     * Но надо что-то отрендерить, потому что мы можем ждать загрузку списка превью курсов
     */
    renderWaiting = () => {
        return this.renderLibraryWrapper(<Spin center />);
    };

    render() {
        const { shouldShowSpinner } = this.props;

        if (shouldShowSpinner) {
            return <Spin center />;
        }

        return this.renderContent();
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps) => {
    const {
        location: { search },
        match: {
            params: { classId: classIdFromUrl, subject },
        },
        isPreview,
    } = ownProps;
    const query = qs.parse(search);
    const classId = Number(classIdFromUrl);
    const currentTeam = getCurrentClass(storeState, { classId });
    const grade = Number(currentTeam?.level || query.grade);

    // чтобы ts не ругался
    const propsWithClassAndGrade = { classId, grade } as PropsWithClassId & PropsWithGrade;

    return {
        currentTeam,
        teamId: classId,
        teams: getClasses(storeState),
        hasActiveDraft: lessonSelectors.getHasActiveDraft(storeState),
        initialSubject: getInitialSubject(storeState),
        lessonId: lessonSelectors.getLessonId(storeState),
        shouldShowSpinner: !isPreview && getIsSubjectListLoading(storeState, propsWithClassAndGrade),
        subjects: (isPreview
            ? getPreviewSubjectLists(storeState)
            : getSubjectLists(storeState, propsWithClassAndGrade)) as CourseSubjectEx[],
        tabs: getSubjectLibraryTabs(storeState, { subject, grade }),
        testId: getExperimentTestId(storeState),
        currentShowcaseSlug: getCurrentShowcaseSlug(storeState),
        isTeacherFromMes: getIsTeacherFromMes(search),
        currentSubjectPageSlug: getCurrentSubjectPageSlug(storeState, { subject, classId, grade }),
        subjectLibraryConfig: getSubjectLibraryConfig(storeState, { subject }),
        shouldShowLibrarySearch: getShouldShowLibrarySearch(storeState, { subject }),
        searchConfig: getSearchConfig(storeState, { subject, grade }),
        isTeamBuilderActive: getIsTeamBuilderActive(storeState),
        grade,
        me: getMe(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => {
    return bindActionCreators(
        {
            toggleLessonWidget: lessonWidgetActions.toggleLessonWidget,
            clearEditor: lessonActions.clearEditor,
            showIntlMessageNotification: showIntlMessageNotificationAction,
        },
        dispatch
    );
};

const withCalendarPlanThemes = (wrappedComponent: ComponentType<Props>) => {
    return withHookProps<Props, Partial<ReturnType<typeof useCalendarPlanThemes>>, CalendarPlanQuery>(
        useCalendarPlanThemes,
        {
            mapOwnProps: (props) => {
                return {
                    subject: props.match.params.subject,
                    grade: props.grade,
                    enabled: !!props.grade && !!props.match.params.subject,
                };
            },
            hookPropKey: 'calendarPlanWithThemes',
        }
    )(wrappedComponent);
};

export default withSubjectGrades(
    withRouterPath(connect(mapStateToProps, mapDispatchToProps)(withCalendarPlanThemes(LibrarySubjectManagerWithMedia)))
);
